<template>
  <div>
    <CustomDrawer v-if="openCustomDrawer" :onClose="() => updateDimensions()" ref="drawer">
      <div slot-scope="slotProps">
        <div class="card">
          <div class="card-header">
            <h5>Выберите габариты препаратов</h5>
          </div>
          <div class="card-body">
            <template v-if="addDimensions">
              <table class="table table-sm table-hover mt-0">
                <tbody>
                <tr v-for="d in missedDrugsDimensions">
                  <td>{{ d.title }}</td>
                  <td>
                    <CountryDimension :drugId="d.id" :records="d.details"/>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="mt-1 text-right">
                <LoadingButton
                  title="Сохранить"
                  className="btn btn-outline-success"
                  :onClick="() => saveDimensions()"
                  :loading="btnLoading"
                  :color="$constants.SUCCESS_COLOR"
                />
              </div>
            </template>
            <template v-else>
              <table class="table table-sm table-hover mt-0">
                <tbody>
                <tr v-for="(r,id) in doubleDrugDimensions">
                  <td>{{ r.drug.title }}</td>
                  <td>
                    <div v-for="(d, i) in r.dimensions" class="border-bottom">
                      <label class="flex flex_gap_5">
                        <input type="radio" v-model="selectedDimensions[id]" :value="i">
                        <span>{{ d.array_value.depth ?? 0 }}/{{ d.array_value.width ?? 0 }}/{{
                            d.array_value.height ?? 0
                          }}/{{ d.array_value.weight ?? 0 }}</span>
                      </label>
                      <p v-if="d.array_value.comment">{{ d.array_value.comment }}</p>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </CustomDrawer>
    <div class="flex flex_gap_10">
      <div>
        <p><strong>{{ volume }} м3</strong> - общий объем</p>
        <p><strong>{{ weight }} кг</strong> - общий вес</p>
        <p v-if="missedDrugsDimensions.length"><strong><span
          class="badge badge-danger pointer" @click="selectDimensions(true)">{{
            missedDrugsDimensions.length
          }}</span></strong> - препаратов без
          данных
        </p>
        <p v-if="Object.keys(doubleDrugDimensions).length">
          <strong><span @click="selectDimensions()" class="badge badge-danger pointer">{{
              Object.keys(doubleDrugDimensions).length
            }}</span></strong>
          - выбрать габариты
        </p>
        <p><strong>{{ getTotalExpenses() }}</strong> - всего расходов!</p>
      </div>
      <div v-if="expenses.length">
        <p>Расходы по поставщику:</p>
        <div class="flex flex_gap_5 flex-wrap">
          <div v-for="e in expenses" class="p-1 border">
            <label><strong>{{ e.totalPrice }}</strong> {{ $AllCurrencies[e.currency_id]?.currency }} -
              {{ $platformConstants.supplierDeliveryExpensesTypes[e.type]?.title }}</label>
            <p>настройки: {{ e.perUnit }} / {{ e.price }} ({{ $AllCurrencies[e.currency_id]?.currency }})</p>
            <p>по факту: {{ e.units }} => {{ e.rate }} * {{ e.price }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CustomDrawer from "@/components/modals/CustomDrawer";
import CountryDimension from "@/views/stores/components/CountryDimension.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  props: ['supplier', 'details'],
  components: {LoadingButton, CountryDimension, CustomDrawer},
  data() {
    return {
      btnLoading: false,
      addDimensions: false,
      openCustomDrawer: false,
      volume: 0,
      weight: 0,
      expenses: [],
      missedDrugsDimensions: [],
      doubleDrugDimensions: {},
      selectedDimensions: {},
      filledDrugs: {},
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  created() {
    this.updateDimensions();
  },
  methods: {
    async saveDimensions() {
      this.btnLoading = true;
      const details = this.missedDrugsDimensions.reduce((acc, d) => {
        d.details.forEach((det) => {
          if (det.alias !== 'dimensions') return;
          if (!det.int_value) return;
          if (Object.keys(det.array_value).find((k) => k !== 'comment' && !det.array_value[k])) return;
          if (!acc[det.drug_id]) acc[det.drug_id] = [];
          acc[det.drug_id].push(det);
        })
        return acc;
      }, {})
      console.log(details);
      let error = false;
      for (let i = 0; i < Object.keys(details).length; i++) {
        const drugId = Object.keys(details)[i];
        const detls = details[Object.keys(details)[i]];
        const {data} = await api.post('/new/drugs/details', {
          type: 'array',
          drug_id: drugId,
          details: detls
        })
        if (!data.success) {
          error = true;
          toastr['warning']((data.message ?? 'Ошибка сервера') + ' препарат ' + drugId, 'Ошибка!');
        } else {
          let index = this.details.findIndex((d) => d.drug_id === drugId);
          if (index !== -1) {
            this.details[index].details = this.details[index].details.concat(detls);
          }
          index = this.missedDrugsDimensions.findIndex((d) => d.id === drugId);
          if (index !== -1) {
            this.missedDrugsDimensions.splice(index, 1);
          }
        }
      }
      if (error) {
        toastr['warning']('Обновите страницу и попробуйте снова', 'Внимание!');
      } else {
        this.updateDimensions();
        toastr['success']('Данные успешно сохранены', 'Успех!');
      }
      this.btnLoading = false;
    },
    updateDimensions() {
      this.weight = 0;
      this.volume = 0;
      this.missedDrugsDimensions = [];
      this.details.forEach((d) => {
        let dimensions = (d.drug?.details ?? []).filter((d) => d.int_value === this.supplier.country_id && d.group_alias === 'country_data' && d.alias === 'dimensions');
        if (!dimensions.length) {
          this.missedDrugsDimensions.push(d.drug);
          return;
        }
        if (dimensions.length > 1) {
          this.doubleDrugDimensions[d.drug.id] = {
            drug: {id: d.drug.id, title: d.drug.title},
            dimensions
          };
        }
        dimensions = dimensions[this.selectedDimensions[d.drug.id]] ?? dimensions[0];
        this.filledDrugs[d.drug.id] = true;
        this.volume += d.qty * (+(dimensions.array_value?.depth ?? 0) * +(dimensions.array_value?.width ?? 0) * +(dimensions.array_value?.height ?? 0));
        this.weight += (d.qty * +(dimensions.array_value?.weight ?? 0));
      })
      this.volume = Math.round(this.volume / 1000 / 1000000 * 100) / 100;
      this.weight = Math.round(this.weight / 1000 * 10) / 10;
      this.calculateExpenses();
    },
    selectDimensions(noDimensions = false) {
      this.openCustomDrawer = true;
      this.addDimensions = noDimensions;
      if (this.$refs.drawer) this.$refs.drawer.open = true;
    },
    getTotalExpenses() {
      return 'xxx';
    },
    calculateExpenses() {
      this.expenses = [];
      (this.supplier.options?.delivery_expenses ?? []).forEach((e) => {
        const exp = {
          type: e.type,
          price: +e.amount,
          currency_id: e.currency_id,
          perUnit: +e.unit,
        };
        let rate;
        switch (e.type) {
          case 'percentByPrice':
            exp.units = this.details.reduce((acc, d) => acc + +d.qty, 0);
            rate = exp.units;
            exp.perUnit = 1;
            exp.totalPrice = Math.round(this.details.reduce((acc, d) => acc + Math.round(+d.qty * +d.income_price * +e.amount / 100 * 10) / 10, 0) * 10) / 10;
            break;
          case 'byItem':
            exp.units = this.details.reduce((acc, d) => acc + +d.qty, 0);
            exp.perUnit = 1;
            rate = exp.units;
            break;
          case 'byWeight':
            exp.units = this.weight;
            rate = Math.ceil(exp.units / +e.unit);
            break;
          case 'byVolume':
            exp.units = this.volume;
            // console.log(exp, e.amount);
            // rate = Math.ceil(exp.units / +e.unit);
            exp.totalPrice = Math.round(+this.volume * +e.amount * 10) / 10;
            break;
        }
        if (!exp.totalPrice) exp.totalPrice = Math.round(rate * +e.amount * 10) / 10;
        this.expenses.push({
          ...exp,
          rate
        });
      })
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
